module.exports = __webpack_public_path__ + "img/GibosaMinguante.e63dfeb1.svg";